import React, { useState, useEffect } from 'react'
import { SeatStatus } from './enums'
import { SegmentedControl, BusSeat } from './index'
import { shouldAcceptSeatClick } from '../../helpers/seatOwnership'

import styles from './TranspaisBusLayout.module.scss'

const TranspaisBusLayout = ({
  layout,
  disponibilidad,
  selected,
  onSelect,
  listPassengers,
  noPets,
  referencia,
  noPetsWindow,
  selectFloor,
  fromReservation,
  tripType, // Nuevo: Tipo de viaje (sencillo o redondo)
  isSelectingReturn, // Nuevo: Indica si estamos seleccionando el viaje de regreso
}) => {
  const [floors, setFloors] = useState([])
  const [selectedFloor, setSelectedFloor] = useState(0)
  const [seatsFloor, setSeatsFloor] = useState([])

  // Cambiar de piso del autobús
  const handleChangeBusFloor = (index) => {
    setSelectedFloor(index)
    selectFloor(index)
  }

  const handleSelectSeat = (seat, isSelected) => {
    if (!shouldAcceptSeatClick(seat.type, isSelected)) return
    // Agregar el sectionId del piso actual al asiento seleccionado
    const seatWithSectionId = {
      ...seat,
      sectionId: layout[selectedFloor]._id, // Agregar el ID del piso actual
    }
    onSelect(seatWithSectionId) // Llamar a `handleSelectSeat` de `BookingBus` con el asiento actualizado
  }

  // Efectos
  useEffect(() => {
    if (layout.length > 0) {
      setSeatsFloor(layout[selectedFloor].rows)
      const floors = layout.length === 1 ? ['Planta baja'] : ['Planta baja', 'Planta alta']
      setFloors(floors)
    }
  }, [layout, selectedFloor])

  const isSeatSelected = (seat) => {
    // console.log('isSelectingReturn: ', isSelectingReturn)
    return selected.some((selectedPassenger) =>
      selectedPassenger.seats.some(
        (selectedSeat) =>
          selectedSeat.seatId === seat.id && // Coincide el ID del asiento
          selectedSeat.type === (isSelectingReturn ? 'return' : 'departure') // Coincide el tipo de asiento
      )
    )
  }

  const x = (column) => {
    const _column = column - 1

    return (_column * 64) + (_column * 30)
  }

  const y = (row, totalRows) => {
    const _row = totalRows - row // Invertir el orden de las filas
    return (_row * 44) + (_row * 30) // 64px de alto + 30px de espacio entre filas
  }

  //Version antigua adaptada
  const SeatSelector = ({ rows }) => {
    const totalRows = 5
    return (
      <>
        {rows?.map((row) =>
          row.seats
            // .sort((a, b) => a.col - b.col) // Ordenar los asientos por la propiedad `col`
            .map((seat) => {
              if (seat?.id && seat.type !== "facilities") {
                const isSelected = isSeatSelected(seat)
                // console.log('isSelected: ', isSelected)
                // Renderizar el asiento
                const isClickable = shouldAcceptSeatClick(seat.type, isSelected)
                return (
                  <BusSeat
                    key={`bs_${seat.id}`}
                    position={{ x: x(seat.row), y: y(seat.col, totalRows) }}
                    type={seat.type === 'WC' ? 'placeholder' : 'default'}
                    variant={'default'}
                    status={
                      SeatStatus.disponible(seat.type) || isSelected
                        ? 'available'
                        : 'unavailable'
                    }
                    value={seat.label}
                    selected={isSelected}
                    // selected={selected.some((selectedSeat) => selectedSeat.id === seat.id)}
                    onClick={() => {
                      if (!isClickable) return
                      const seatWithRow = { ...seat, itemRow: row.label } // Agregar la fila al asiento
                      handleSelectSeat(seatWithRow, isSelected)
                    }}
                    categoria={0}
                    destacado={""}
                  />
                )
              }
  
              return null
            })
        )}
      </>
    )
  }

  return (
    <>
      <SegmentedControl items={floors} selected={selectedFloor} onChange={handleChangeBusFloor} />

      <div className={styles.busLayout}>
        {selectedFloor === 0 && <div className={styles.volante}></div>}
        <div>
          <SeatSelector rows={seatsFloor} selected={selected} />
        </div>
      </div>
    </>
  )
}

export default TranspaisBusLayout